/**
 * Enterprise layout for Flash AI Assistant page.
 * Renders: main workspace (header + children) + collapsible right panel.
 * State (rightPanelOpen, conversations, usage, etc.) is owned by the parent (FlashChatWorkspace).
 */
import React from "react";
import RightPanel from "./RightPanel";
import styles from "./FlashAssistant.module.scss";

export default function FlashAssistantLayout({
  rightPanelOpen,
  onToggleRightPanel,
  conversations,
  activeConversationId,
  onSelectConversation,
  onCreateConversation,
  usage,
  insightText,
  onMessageStudent,
  onCreateFollowUp,
  onExportEnquiries,
  children,
}) {
  return (
    <div className={styles.abyssLayout}>
      <div
        className={`${styles.mainWorkspace} ${
          rightPanelOpen ? styles.mainWorkspacePanelOpen : styles.mainWorkspacePanelCollapsed
        }`}
      >
        {children}
      </div>
      <div
        className={
          rightPanelOpen ? styles.rightPanelWrapper : styles.rightPanelWrapperCollapsed
        }
      >
        <RightPanel
        rightPanelOpen={rightPanelOpen}
        onToggle={onToggleRightPanel}
        conversations={conversations}
        activeConversationId={activeConversationId}
        onSelectConversation={onSelectConversation}
        onCreateConversation={onCreateConversation}
        usage={usage}
        insightText={insightText}
        onMessageStudent={onMessageStudent}
        onCreateFollowUp={onCreateFollowUp}
        onExportEnquiries={onExportEnquiries}
        />
      </div>
    </div>
  );
}
